<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12">
        <div class="card mt-3">
          
          <div class="card-header pb-0 bg-transparent border-0">
            <h5 class="mb-0 text-dark">{{ $t('apps.gtimeAllow') }}</h5>
          </div>

          <div class="card-body pt-3 mt-4">
            <!-- ส่วนฟอร์มกรอกข้อมูล (เปลี่ยนตัวครอบหลักให้เป็น d-flex align-items-center เพื่อจับทุกชิ้นอยู่กึ่งกลางระนาบแนวดิ่งเท่ากันเป๊ะ) -->
            <div class="d-flex flex-wrap align-items-center gap-4">
            
            <!-- เวลาเริ่มต้น -->
            <div class="d-flex align-items-center gap-2" style="width: 240px;">
                <label for="timeonly_start" class="font-bold text-nowrap mb-0" style="min-width: 70px;">
                {{ $t('content.amntimestart') }}
                </label>
                <input 
                type="text" 
                id="timeonly_start" 
                v-model="time_starts_string" 
                @input="formatTimeInput('start')"
                class="form-control mb-0"
                :disabled="allTime"
                placeholder="00:00"
                maxlength="5"
                style="padding: 0.5rem; border: 1px solid #ced4da; border-radius: 4px; text-align: center;"
                >
            </div>

            <!-- เวลาสิ้นสุด -->
            <div class="d-flex align-items-center gap-2" style="width: 240px;">
                <label for="timeonly_end" class="font-bold text-nowrap mb-0" style="min-width: 70px;">
                {{ $t('content.amntimeend') }}
                </label>
                <input 
                type="text" 
                id="timeonly_end" 
                v-model="time_ends_string" 
                @input="formatTimeInput('end')"
                class="form-control mb-0"
                :disabled="allTime"
                placeholder="23:59"
                maxlength="5"
                style="padding: 0.5rem; border: 1px solid #ced4da; border-radius: 4px; text-align: center;"
                >
            </div>

            <!-- ติ๊กอนุญาตตลอดเวลา (ปรับดีไซน์ใหม่ให้เป็นสไตล์ Material Design สวยงาม อยู่กึ่งกลางระนาบเป๊ะ) -->
            <div class="d-flex align-items-center mb-0" style="height: 38px;">
            <!-- ตัวครอบ Checkbox เพื่อทำ Effect สไตล์ Material -->
            <label class="material-checkbox-container d-flex align-items-center mb-0" style="cursor: pointer; user-select: none;">
                <input 
                type="checkbox" 
                id="allTimeCheckbox" 
                v-model="allTime"
                @change="toggleAllTime"
                class="material-custom-input"
                >
                <!-- กล่องสี่เหลี่ยมจำลองหน้าตาแบบ Material -->
                <span class="material-checkmark"></span>
                <span class="font-bold ms-2">อนุญาตเข้าระบบตลอดเวลา</span>
            </label>
            </div>

            </div>


            <hr class="my-4 rgba-black-light">

            <!-- ส่วนปุ่มดำเนินการควบคุม -->
            <div class="row">
              <div class="col-12 d-flex justify-content-end align-items-center gap-2">
                <!-- ปุ่มบันทึก (สั่ง disabled ทันทีหากกรอกเวลายังไม่ครบ 5 หลัก หรือเวลาเริ่มมากกว่าเวลาจบ) -->
                <material-button 
                color="primary" 
                class="mb-0" 
                :title="btnSave" 
                @click="setLoginWindow" 
                :disabled="!allTime && (time_starts_string.length !== 5 || time_ends_string.length !== 5)"
                >
                <i class="material-icons material-symbols-outlined me-1">save</i> 
                {{ btnSave }}
                </material-button>

                <material-button 
                  id="cardSearch" 
                  color="danger" 
                  class="mb-0" 
                  @click="getcurrentWindow"
                >
                  <i class="material-icons material-symbols-outlined me-1">close</i> 
                  {{ $t('buttons.canc') }}
                </material-button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>




<script setup>
/* eslint-disable no-unused-vars */
import { reactive, inject, computed, ref, onMounted } from 'vue'
import { useI18n } from "vue-i18n"

import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialButton from "@/components/MaterialButton.vue"

import { useLoginWindowStore } from '@/stores/loginwindow'

const stores = useLoginWindowStore()

// เปลี่ยนการเก็บค่าจากออบเจกต์ Date มาเก็บเป็นแบบข้อความสตริง "HH:mm" ตรงๆ เพื่อรองรับการพิมพ์
const time_starts_string = ref('06:30')
const time_ends_string = ref('19:00')
const allTime = ref(false)

const { t } = useI18n()
const swal = inject('$swal')

const btnSave = computed(() => t("buttons.save"))

// ฟังก์ชันสลับกล่อง Checkbox
const toggleAllTime = () => {
   if (allTime.value) {
    // ถ้าติ๊กถูกให้แอบเคลียร์สเตต (หรือตามใจคุณ)
    time_starts_string.value = '00:00'
    time_ends_string.value = '23:59'
  } else {
    // [จุดสำคัญ] ถ้าเอาติ๊กออก ให้ระบบดีดเวลากลับมาเป็นค่า Default "06:30" และ "19:00" ทันที
    time_starts_string.value = '06:30'
    time_ends_string.value = '19:00'
  }
}

const formatTimeInput = (type) => {
  // ดึงค่าปัจจุบันออกมาล้างให้เหลือแต่ตัวเลขล้วน
  let value = type === 'start' ? time_starts_string.value : time_ends_string.value
  value = value.replace(/\D/g, '') // ลบทุกอย่างที่ไม่ใช่ตัวเลขออกทั้งหมด

  // ตรวจสอบและจำกัดตัวเลขชั่วโมง (2 ตัวแรกต้องไม่เกิน 23)
  if (value.length >= 2) {
    let hours = parseInt(value.slice(0, 2))
    if (hours > 23) hours = 23
    // แปลงกลับเป็นสตริงที่มีเลข 0 นำหน้าถ้าจำเป็น
    value = String(hours).padStart(2, '0') + value.slice(2)
  }

  // ตรวจสอบและจำกัดตัวเลขนาที (2 ตัวหลังต้องไม่เกิน 59)
  if (value.length >= 4) {
    let minutes = parseInt(value.slice(2, 4))
    if (minutes > 59) minutes = 59
    value = value.slice(0, 2) + String(minutes).padStart(2, '0')
  }

  // จัดรูปแบบใส่เครื่องหมาย : คั่นกลางให้อัตโนมัติเมื่อพิมพ์ตัวเลขเกิน 2 ตัว
  if (value.length > 2) {
    value = value.slice(0, 2) + ':' + value.slice(2, 4)
  }

  // อัปเดตค่าย้อนกลับไปที่ตัวแปรหลักของ Vue
  if (type === 'start') {
    time_starts_string.value = value
  } else {
    time_ends_string.value = value
  }
}

async function getcurrentWindow() {
  try {
    const response = await stores.currentWindowFetch()
    if (response) {
      //   console.log('Response Object:', response)
      
      // 1. แกะโครงสร้างข้อมูลชั้นในสุดให้ถูกต้อง (รองรับโครงสร้าง API)
      let targetData = null
      if (response.data && response.data.data) {
        targetData = response.data.data
      } else if (response.data) {
        targetData = response.data
      } else {
        targetData = response
      }

      if (targetData) {
        // 2. [จุดสำคัญ] เช็คสถานะ allTime จากคำว่า 'ALL-TIME' เท่านั้นตามเงื่อนไขใหม่
        if (targetData.userLoginWindow === 'ALL-TIME') {
          allTime.value = true
          time_starts_string.value = '00:00'
          time_ends_string.value = '23:59'
        } else {
          allTime.value = false
          
          // 3. ถ้าไม่ใช่ ALL-TIME (เช่น "00:10-23:55") ให้แยกสายอักษรเอาไปใส่ช่องพิมพ์
          if (targetData.userLoginWindow) {
            const times = targetData.userLoginWindow.split('-') // แยกได้ ['00:10', '23:55']
            if (times.length === 2) {
              time_starts_string.value = times[0] // ป้อนค่า "00:10"
              time_ends_string.value = times[1]   // ป้อนค่า "23:55"
            }
          }
        }
      }
    }
  } catch (error) {
    console.error('Error fetching shop info:', error)
  }
}


onMounted(() => {
  getcurrentWindow()
})

async function setLoginWindow() {
  try {
    let userLoginWindow = null    
    
    if (allTime.value) {
      userLoginWindow = 'ALL-TIME'
    } else {
      // 1. ดักจับกรณีผู้ใช้กรอกข้อมูลไม่ครบถ้วน (ต้องยาว 5 ตัวอักษรพอดี เช่น 08:30)
      if (!time_starts_string.value || time_starts_string.value.length !== 5 ||
          !time_ends_string.value || time_ends_string.value.length !== 5) {
        swal("กรุณากรอกเวลาให้ครบถ้วน", "รูปแบบที่ถูกต้องคือ ชั่วโมง:นาที (เช่น 08:30)", "warning")
        return // สั่งหยุดทำงานทันที
      }

      // 2. ตรวจสอบโครงสร้างว่ามีเครื่องหมายโคลอน (:) ตรงตำแหน่งที่ถูกต้องไหม
      if (!time_starts_string.value.includes(':') || !time_ends_string.value.includes(':')) {
        swal("รูปแบบเวลาไม่ถูกต้อง", "กรุณาตรวจสอบเครื่องหมายคั่นเวลา (:)", "warning")
        return // สั่งหยุดทำงานทันที
      }

      // 3. แปลงเวลาเป็นตัวเลขชั่วโมงและนาทีเพื่อนำมาเปรียบเทียบค่า
      const [startHour, startMin] = time_starts_string.value.split(':').map(Number)
      const [endHour, endMin] = time_ends_string.value.split(':').map(Number)

      // คำนวณเวลาทั้งหมดให้ออกมาเป็นหน่วย "นาทีรวมของวัน" เพื่อให้เปรียบเทียบง่าย
      const totalStartMinutes = (startHour * 60) + startMin
      const totalEndMinutes = (endHour * 60) + endMin

      // 4. ดักจับกรณีเวลาเริ่มต้น มากกว่าหรือเท่ากับ เวลาสิ้นสุด
      if (totalStartMinutes >= totalEndMinutes) {
        swal(
          "ช่วงเวลาไม่ถูกต้อง", 
          `เวลาเริ่มต้น (${time_starts_string.value}) ต้องน้อยกว่าเวลาสิ้นสุด (${time_ends_string.value})`, 
          "warning"
        )
        return // สั่งหยุดทำงานทันที ไม่ส่งค่ามั่วไปหลังบ้าน
      }

      // ผ่านทุกเงื่อนไข จัดร่างข้อความส่ง payload
      userLoginWindow = `${time_starts_string.value}-${time_ends_string.value}`
    }

    const payload = { userLoginWindow: userLoginWindow }
    // console.log('Payload ที่ผ่านการตรวจสอบและกำลังจะส่ง:', payload)

    // ส่งค่าไปบันทึกที่เซิร์ฟเวอร์ หลังบ้านจะปลอดภัยแน่นอน 100%
    const response = await stores.setLoginWindowFetch(payload)
    if (response && response.status === 200) {
      const resData = response.data ? response.data : response
      if (resData.rtnDesc === "success") {
        await getcurrentWindow()
        swal("บันทึกสำเร็จ", "", "success")
      } else {
        swal("บันทึกไม่สำเร็จ", "", "error")
      }
    }
  } catch (error) {
    console.error('Error updating shop info:', error)
    swal("เกิดข้อผิดพลาด", "ไม่สามารถเชื่อมต่อฐานข้อมูลได้", "error")
  }
}


</script>



<style scoped>
/* 1. จัดการตัวครอบหลัก */
.material-checkbox-container {
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* 2. ซ่อน Checkbox ดั้งเดิมของบราวเซอร์ทิ้งไป */
.material-custom-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* 3. สร้างกล่องสี่เหลี่ยมดั้งเดิมสไตล์ Material (จังหวะยังไม่ได้ติ๊ก) */
.material-checkmark {
  position: relative;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 2px solid #b0bec5; /* สีขอบเทาจางสไตล์ Material */
  border-radius: 4px; /* ขอบมนสวยงาม */
  transition: all 0.2s ease-in-out;
  display: inline-block;
}

/* 4. สไตล์ตอนที่กดติ๊กถูก (เปลี่ยนพื้นหลังเป็นสีเขียวและเปลี่ยนสีขอบ) */
.material-custom-input:checked ~ .material-checkmark {
  background-color: #4CAF50; /* สีเขียวหลักของระบบ */
  border-color: #4CAF50;
  box-shadow: 0 2px 5px rgba(76, 175, 80, 0.3); /* มิติเงาสะท้อนด้านล่าง */
}

/* 5. สร้างเครื่องหมายถูกสีขาวซ่อนไว้ข้างใน */
.material-checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* 6. เปิดแสดงเครื่องหมายถูกเมื่อโดนติ๊ก */
.material-custom-input:checked ~ .material-checkmark:after {
  display: block;
}

/* 7. วาดรูปเครื่องหมายถูกสีขาวให้คมชัดและเอียงสวยงาม */
.material-checkbox-container .material-checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0; /* ความหนาของเส้นเครื่องหมายถูก */
  transform: rotate(45deg); /* หมุนให้กลายเป็นมุมเครื่องหมายถูก */
}

/* 8. เพิ่ม Effect แสงสะท้อนกลมๆ วงนอกเวลาเอาเมาส์ไปชี้ (Hover Effect) */
.material-checkbox-container:hover .material-checkmark {
  border-color: #4CAF50;
}
</style>
